module.exports = function getResource(label, vars = []) {
    const resources = {
        please: 'Please',
        signIn: 'sign in',
        review: 'to review this section.'
    };

    return resources[label];
};
